// extracted by mini-css-extract-plugin
export default {"container":"newWhyUs_container__FjRQq","gridContainer":"newWhyUs_gridContainer__F-t9+"};